var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBdiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_486",
    "data-name": "\\uADF8\\uB8F9 486",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 154.531,
    height: 28.549,
    viewBox: "0 0 154.531 28.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 154.531,
    height: 28.548,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1",
    "data-name": "\\uADF8\\uB8F9 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M305.077,21.154a2.936,2.936,0,0,1-2.935,2.936h-1.966V6.925h1.966a2.935,2.935,0,0,1,2.935,2.934ZM302.4,1.529h-7.32a.586.586,0,0,0-.587.587V28.9a.586.586,0,0,0,.587.587h7.32a8.365,8.365,0,0,0,8.364-8.364V9.893A8.365,8.365,0,0,0,302.4,1.529",
    transform: "translate(-185.159 -0.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M352.812,29.455h-4.494a.587.587,0,0,1-.587-.587V2.069a.587.587,0,0,1,.587-.587h4.494a.587.587,0,0,1,.587.587v26.8a.587.587,0,0,1-.587.587",
    transform: "translate(-218.634 -0.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M378.079,15.128V7.854a2.468,2.468,0,0,1,4.935.016v7.258Zm10.6-6.979a8.136,8.136,0,1,0-16.272-.024V27.937a.587.587,0,0,0,.587.587h4.5a.587.587,0,0,0,.587-.587V20.519h4.935v7.418a.587.587,0,0,0,.587.587H388.1a.587.587,0,0,0,.587-.587V8.148Z",
    transform: "translate(-234.151 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M253.478,9.941a2.935,2.935,0,0,1-2.935,2.935h-1.966V6.985h1.966a2.935,2.935,0,0,1,2.935,2.934Zm0,11.282a2.935,2.935,0,0,1-2.935,2.935h-1.966V18.267h1.966a2.935,2.935,0,0,1,2.935,2.936Zm5.668-11.3a8.324,8.324,0,0,0-8.325-8.325H243.5a.587.587,0,0,0-.588.588v26.78a.587.587,0,0,0,.588.588h7.324a8.324,8.324,0,0,0,8.325-8.325V21.2a8.283,8.283,0,0,0-2.2-5.629,8.284,8.284,0,0,0,2.2-5.629Z",
    transform: "translate(-152.728 -1.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M54.068,5.612H49.9a.544.544,0,0,0-.544.544V31a.544.544,0,0,0,.544.544h4.166A.544.544,0,0,0,54.613,31V6.156a.544.544,0,0,0-.544-.544",
    transform: "translate(-31.034 -3.529)",
    fill: "#570ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M126.3,5.612h-4.166a.544.544,0,0,0-.545.544V31a.544.544,0,0,0,.545.544H126.3a.544.544,0,0,0,.544-.544V6.156a.544.544,0,0,0-.544-.544",
    transform: "translate(-76.452 -3.529)",
    fill: "#570ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M86.778,5.612H79.991a7.754,7.754,0,0,0-7.754,7.754V23.774a7.754,7.754,0,0,0,7.754,7.754h6.786a.544.544,0,0,0,.544-.544V27.075a.544.544,0,0,0-.544-.544H80.213a2.721,2.721,0,0,1-2.721-2.721V13.33a2.721,2.721,0,0,1,2.721-2.721h6.565a.544.544,0,0,0,.544-.544V6.156a.544.544,0,0,0-.544-.544",
    transform: "translate(-45.419 -3.529)",
    fill: "#570ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M203.119,16.079h-4.031V6.155a.544.544,0,0,0-.544-.544h-4.166a.544.544,0,0,0-.544.544V31a.544.544,0,0,0,.544.544h4.166a.544.544,0,0,0,.544-.544V21.076h4.031a.544.544,0,0,0,.544-.544V16.623a.544.544,0,0,0-.544-.544",
    transform: "translate(-121.872 -3.528)",
    fill: "#570ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9",
    "data-name": "\\uD328\\uC2A4 9",
    d: "M154.305,23.89a2.288,2.288,0,0,1-4.577,0V11.465a2.288,2.288,0,0,1,4.577,0ZM152.017,4.179a7.543,7.543,0,0,0-7.543,7.543V23.633a7.543,7.543,0,1,0,15.086,0V11.722a7.543,7.543,0,0,0-7.543-7.543",
    transform: "translate(-90.837 -2.628)",
    fill: "#570ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10",
    "data-name": "\\uD328\\uC2A4 10",
    d: "M9.83,24.819a2.288,2.288,0,0,1-4.575.013V18.089H9.83Zm4.71-19.148H10.374a.544.544,0,0,0-.544.544v6.876H5.255V6.215a.544.544,0,0,0-.544-.544H.544A.545.545,0,0,0,0,6.215V24.582a7.542,7.542,0,0,0,15.085-.022V6.215a.544.544,0,0,0-.544-.544",
    transform: "translate(0 -3.566)",
    fill: "#570ae3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdiaLogo);
export default __webpack_public_path__ + "static/media/bdia_logo.7b1fb6d544395807d86e2569c32cfdf3.svg";
export { ForwardRef as ReactComponent };